<!-- Breadcrumb Header -->
<div class="bg-light-primary rounded p-y-10 p-x-24 m-b-10 overflow-hidden">
  <div class="row">
    <div class="col-sm-8">
      <h4 class="page-title m-0 f-s-20 f-w-700 m-b-10">
        {{ breadcrumbData.title | translate }}
      </h4>
      <div class="d-flex justify-content-start align-items-center">
        <ul class="breadcrumb">
          @for (url of breadcrumbData.urls; track url.title; let index = $index; let last = $last) {
            @if (!last) {
              <li class="breadcrumb-item">
                @if (url.url) {
                  <a [routerLink]="url.url">{{ url.title | translate }}&nbsp;>&nbsp;</a>
                } @else {
                  <span class="cursor-pointer" (click)="resetNavigation()">{{ url.title | translate }}&nbsp;>&nbsp;</span>
                }
              </li>
            } @else {
              <li class="breadcrumb-item active">{{ url.title | translate }}</li>
            }
          }
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Conditional Content Rendering -->
@if (currentLevel === 'ward') {
  <app-ward (wardClick)="onWardClick($event)"></app-ward>
} @else if (currentLevel === 'roomtype') {
  <app-room-type 
    [wardId]="wardId" 
    (roomTypeClick)="onRoomTypeClick($event)">
  </app-room-type>
} @else if (currentLevel === 'room') {
  <app-room 
    [roomTypeId]="roomTypeId"
    (roomClick)="onRoomClick($event)">
  </app-room>
} @else if (currentLevel === 'bed') {
  <app-bed [roomId]="roomId"></app-bed>
}